"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "How does sealing extend the lifespan of my concrete or stone?",
  answer: "Our advanced sealants penetrate deep into the substrate, creating a durable barrier against moisture, chemicals, and freeze-thaw cycles. This protection prevents cracking, spalling, and erosion, significantly prolonging the life of your surfaces while maintaining their structural integrity."
}, {
  question: "Are your sealants environmentally safe?",
  answer: "Yes. Island Seals is committed to environmental responsibility. We use industry-leading, eco-friendly sealants that are low in VOCs (Volatile Organic Compounds) and safe for surrounding vegetation, pets, and your family, without compromising on performance or durability."
}, {
  question: "Will the sealant alter the appearance of my surfaces?",
  answer: "We offer a range of finishes tailored to your aesthetic preferences. While some sealants are designed to be invisible and maintain the natural look of the stone or concrete, others can provide a 'wet look' or color enhancement. We will discuss the best option for your specific project during our assessment."
}, {
  question: "How often should surfaces be resealed?",
  answer: "The longevity of a seal depends on the surface type, exposure to elements, and traffic levels. Generally, we recommend a professional inspection every 3 to 5 years. Our high-quality industrial sealants are designed for long-term protection, often outlasting standard hardware store products."
}, {
  question: "Do you service both residential and commercial properties?",
  answer: "Absolutely. We serve a diverse clientele ranging from private homeowners to large industrial facilities. Whether it's a residential driveway, a commercial pool deck, or an industrial warehouse floor, our team is equipped to handle projects of any scale with the same level of precision and care."
}];
export default function ProtectionFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="protection-faq" className="bg-accent py-20 sm:py-28">
      <div ref={ref} className={`mx-auto max-w-3xl px-6 transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Protection FAQ
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Common questions about our sealing and waterproofing services.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/60 last:border-0" data-index={i}>
              <AccordionTrigger className="group py-6 text-left hover:no-underline [&>svg:last-child]:hidden">
                <span className="text-lg font-bold text-foreground">
                  {item.question}
                </span>
                <div className="relative flex size-5 shrink-0 items-center justify-center text-primary">
                  <Plus className="absolute size-5 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                  <Minus className="absolute size-5 rotate-90 opacity-0 transition-transform duration-300 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}